var _defs, _sodipodiNamedview;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealthyLifestyle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlSpace: "preserve",
    width: 126.40613,
    height: 126.406,
    viewBox: "0 0 126.40613 126.406",
    sodipodidocname: "Healthy Lifestyle.ai",
    xmlnsinkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnssodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnssvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,94.805 H 94.805 V 0 H 0 Z",
    id: "path14"
  })))), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview4",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    inkscapepageshadow: 2,
    inkscapepageopacity: 0,
    inkscapepagecheckerboard: 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    inkscapegroupmode: "layer",
    inkscapelabel: "Healthy Lifestyle",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,126.406)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12",
    clipPath: "url(#clipPath16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g18",
    transform: "translate(68.7298,66.9301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 0.128,1.314 0.466,1.656 1.784,1.756 3.868,1.914 5.453,3.524 5.519,5.549 5.584,7.517 4.096,9.27 2.145,9.522 0.544,9.729 0.082,10.54 0.711,12.043 c 0.563,1.347 0.282,2.834 -0.727,3.85 -1.018,1.024 -2.585,1.323 -3.91,0.747 -1.316,-0.573 -2.132,-1.852 -2.107,-3.304 0.019,-1.186 -0.276,-1.581 -1.433,-1.911 -1.673,-0.477 -2.612,-1.921 -2.296,-3.647 0.13,-0.71 -0.032,-1.244 -0.501,-1.775 -1.277,-1.451 -0.704,-3.6 1.14,-4.162 1.002,-0.305 1.464,-0.845 1.511,-1.908 0.079,-1.784 2.172,-3.687 3.979,-3.414 0.65,0.098 1.88,0.642 2.431,1 C -0.276,-1.88 -0.088,-0.909 0,0",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g22",
    transform: "translate(89.4464,42.8007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -9.011 c -0.72,0 -1.32,0.507 -1.465,1.183 -0.073,0.217 -0.126,0.454 -0.14,0.733 -0.27,5.311 -2.782,9.203 -7.599,11.427 -5.475,2.528 -11.001,0.749 -14.769,-3.601 l -0.002,0.002 c -0.032,-0.044 -0.074,-0.08 -0.11,-0.12 -0.268,-0.41 -0.729,-0.682 -1.255,-0.682 h -1.917 c -0.828,0 -1.5,0.672 -1.5,1.5 0,0.829 0.672,1.5 1.5,1.5 h 1.176 c 2.619,3.04 5.856,4.891 10.09,5.591 -0.158,0.039 -0.315,0.092 -0.476,0.115 -2.782,0.394 -5.011,2.404 -5.71,5.103 -0.072,0.277 -0.312,0.586 -0.561,0.728 -2.851,1.631 -3.767,5.094 -2.083,7.896 0.159,0.265 0.238,0.616 0.244,0.93 0.043,2.52 1.112,4.433 3.335,5.65 0.374,0.205 0.526,0.429 0.611,0.846 0.67,3.28 3.626,5.517 6.878,5.244 3.385,-0.285 6.009,-2.931 6.025,-6.316 0.006,-1.078 0.296,-1.544 1.211,-2.087 2.529,-1.5 3.643,-3.868 3.251,-6.773 -0.387,-2.874 -2.095,-4.782 -4.859,-5.683 -0.494,-0.161 -0.744,-0.369 -0.905,-0.879 -0.564,-1.79 -1.722,-3.111 -3.386,-3.984 -0.506,-0.266 -0.505,-0.268 -0.424,-0.9 2.095,-0.243 4.118,-0.796 5.96,-1.86 C -10.961,12.717 -8.199,8.535 -7.685,3 H 0 C 0.829,3 1.5,2.329 1.5,1.5 1.5,0.671 0.829,0 0,0 m -23.431,-31.559 c -7.802,0 -14.149,6.347 -14.149,14.149 0,7.802 6.347,14.149 14.149,14.149 7.802,0 14.149,-6.347 14.149,-14.149 0,-7.802 -6.347,-14.149 -14.149,-14.149 m -16.841,23.082 c -1.755,0 -3.375,0.647 -4.827,1.923 0.305,-1.822 0.66,-3.673 1.006,-5.32 0.151,-0.716 0.153,-1.443 0.007,-2.162 -2.22,-10.891 -2.554,-11.559 -2.774,-12.002 -1.217,-2.44 -3.673,-3.956 -6.41,-3.956 -0.567,0 -1.133,0.068 -1.681,0.203 -3.438,0.843 -5.7,3.627 -5.763,7.091 -0.005,0.252 -0.012,0.66 0.291,2.36 -1.396,-1.729 -3.531,-2.754 -5.773,-2.754 -1.596,0 -3.115,0.501 -4.395,1.448 l -0.08,0.06 -0.076,0.064 -6.089,5.168 c -1.534,1.172 -2.534,2.868 -2.821,4.79 -0.164,1.098 -0.083,2.194 0.226,3.224 -1.419,0.314 -2.766,1.082 -3.894,2.236 -2.71,2.774 -2.716,7.314 -0.014,10.12 3.037,3.153 6.263,6.375 9.589,9.574 1.345,1.294 2.904,2.219 4.58,2.745 -2.192,2.411 -3.528,5.626 -3.538,9.219 -0.019,7.495 6.122,13.615 13.701,13.643 h 0.038 c 3.52,0 6.87,-1.409 9.433,-3.968 2.609,-2.603 4.043,-6.025 4.037,-9.635 -0.006,-3.643 -1.302,-6.858 -3.461,-9.26 1.806,-0.565 3.498,-1.603 5.044,-3.117 2.966,-2.904 5.907,-5.907 8.751,-8.811 2.279,-2.327 2.956,-5.197 1.908,-8.083 -0.934,-2.574 -3.024,-4.246 -5.885,-4.708 -0.377,-0.061 -0.757,-0.092 -1.13,-0.092 m 21.11,54.582 c -22.921,12.638 -51.748,4.301 -64.386,-18.621 -12.637,-22.922 -4.3,-51.748 18.622,-64.386 22.921,-12.638 51.748,-4.301 64.386,18.621 12.637,22.922 4.3,51.748 -18.622,64.386",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g26",
    transform: "translate(30.3403,57.7256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 0.018 0.019 C 6.045,0.01 10.597,4.598 10.607,10.674 10.611,13.48 9.49,16.145 7.451,18.18 5.453,20.175 2.856,21.272 0.137,21.272 H 0.099 C -5.816,21.25 -10.617,16.479 -10.602,10.637 -10.586,4.669 -5.931,0 0,0",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g30",
    transform: "translate(66.0156,36.5395)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -6.157,0 -11.149,-4.992 -11.149,-11.149 0,-6.158 4.992,-11.149 11.149,-11.149 6.157,0 11.149,4.991 11.149,11.149 C 11.149,-4.992 6.157,0 0,0",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path32"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g34",
    transform: "translate(52.1382,45.1076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -2.881,2.942 -5.764,5.885 -8.706,8.766 -1.515,1.482 -3.292,2.514 -5.403,2.725 -2.189,-1.427 -4.813,-2.259 -7.665,-2.263 h -0.024 c -2.863,0 -5.495,0.829 -7.69,2.257 -1.873,-0.212 -3.513,-1.055 -4.874,-2.364 -3.227,-3.104 -6.402,-6.267 -9.508,-9.493 -1.566,-1.626 -1.579,-4.327 -0.001,-5.942 0.961,-0.984 2.088,-1.494 3.209,-1.494 0.958,0 1.913,0.372 2.759,1.138 1.671,1.514 5.474,5.23 5.963,5.603 0,-4.631 -0.003,-6.462 -0.003,-8.502 l -0.009,0.005 v -0.675 c 0,-0.553 -0.447,-1 -1,-1 -0.552,0 -1,0.447 -1,1 v 1.719 c -1.679,0.422 -3.53,-0.169 -4.62,-1.641 -1.44,-1.946 -1.026,-4.716 0.919,-6.156 l 6.155,-5.225 c 1.946,-1.44 4.716,-1.026 6.156,0.919 0.756,1.021 0.797,3.617 0.798,3.716 0.021,2.877 0.002,1.393 0,4.27 0,1.824 1.629,2.44 2.71,1.983 1.188,-0.503 2.183,-3.38 2.794,-4.877 0.201,-0.493 0.246,-1.027 0.132,-1.547 -0.431,-1.956 -1.515,-6.979 -1.499,-7.874 0.039,-2.12 1.423,-3.728 3.479,-4.233 0.318,-0.078 0.642,-0.116 0.966,-0.116 1.507,0 2.993,0.827 3.725,2.295 0.356,0.713 2.088,9.148 2.519,11.263 0.064,0.313 0.064,0.631 -0.002,0.944 -0.404,1.923 -1.902,9.321 -1.902,13.386 0,0 3.743,-3.083 5.378,-4.779 0.903,-0.937 1.978,-1.591 3.28,-1.591 0.212,0 0.429,0.017 0.652,0.053 1.68,0.271 2.954,1.146 3.544,2.769 C 1.919,-3.068 1.367,-1.395 0,0",
    style: {
      fill: "#white",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path36"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthyLifestyle);
export default __webpack_public_path__ + "static/media/healthy_lifestyle.744dd086b4c96225f6f7940bf9d784df.svg";
export { ForwardRef as ReactComponent };